import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { map } from 'rxjs/operators';
import { RackeoLocaleService, RackeoContactData } from '../../services/locale.service';
import { SlaaskChatService } from '../../services/slaask-chat.service';
import { URL } from '../../../../environments/environment';
import { CountryCode, RackeoCountryOption, RACKEO_COUNTRIES, RACKEO_SITE, getRackeoCountryUrl } from '../../rackeo-site';

type HelpActionKey = 'phone' | 'portal' | 'chat';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  readonly URL = URL;
  readonly site = RACKEO_SITE;
  readonly countries = RACKEO_COUNTRIES;
  readonly helpSelectEmptyValue = undefined;

  helpSelection?: HelpActionKey;

  private readonly defaultContact = {
    phoneDisplay: '+56 2 3384 9654',
    phoneTel: '+56233849654',
    phoneKicker: 'Atención cliente',
    chatLabel: 'Portal de solicitudes'
  };

  readonly contact$ = this.locale.getContent().pipe(
    map((c) => c?.contact ?? this.defaultContact)
  );

  constructor(
    private readonly locale: RackeoLocaleService,
    private readonly slaaskChat: SlaaskChatService,
    @Inject(PLATFORM_ID) private readonly platformId: object
  ) { }

  openSlaaskChat(): void {
    void this.slaaskChat.open();
  }

  onHelpSelection(action: HelpActionKey | undefined, contact: RackeoContactData): void {
    if (!action || !isPlatformBrowser(this.platformId)) {
      return;
    }

    if (action === 'phone') {
      globalThis.location.href = `tel:${contact.phoneTel}`;
    } else if (action === 'portal') {
      globalThis.open(contact.chatUrl || URL.SUPPORT_CHAT, '_blank', 'noopener,noreferrer');
    } else if (action === 'chat') {
      this.openSlaaskChat();
    }

    this.helpSelection = action;
    Promise.resolve().then(() => {
      this.helpSelection = undefined;
    });
  }

  get currentCountryOption(): RackeoCountryOption | undefined {
    return this.countries.find((c) => c.code === this.site.countryCode);
  }

  onCountrySelection(code: CountryCode): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const normalized = typeof code === 'string' ? (code.trim().toUpperCase() as CountryCode) : code;
    const option = this.countries.find((c) => c.code === normalized);
    if (!option) {
      return;
    }
    const target = getRackeoCountryUrl(option.code);
    if (!target.startsWith('https://')) {
      return;
    }
    globalThis.location.replace(target);
  }
}
